const React = require('react')

const BlockchainNavIcon = props => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='1.5em'
            height='1.5em'
            viewBox='0 0 22 22'
            fill={props.color || 'currentColor'}
        >
            <circle cx='3.5' cy='18.5' r='3' fill='currentColor' />
            <circle cx='18.5' cy='3.5' r='3' fill='currentColor' />
            <circle cx='4.25' cy='4.25' r='2.25' fill='currentColor' />
            <circle cx='17.8101' cy='17.7876' r='2.25' transform='rotate(-180 17.8101 17.7876)' fill='currentColor' />
            <rect
                x='17.1509'
                y='4.4729'
                width='0.834817'
                height='2.96387'
                transform='rotate(45.5297 17.1509 4.4729)'
                fill='currentColor'
            />
            <rect
                width='0.8325'
                height='3.137'
                transform='matrix(-0.700539 0.713614 0.713614 0.700539 4.83301 4.25)'
                fill='currentColor'
            />
            <rect
                width='0.8325'
                height='2.71695'
                transform='matrix(0.700539 -0.713614 -0.713614 -0.700539 16.8909 17.4458)'
                fill='currentColor'
            />
            <rect
                x='6.49414'
                y='14.9724'
                width='0.8325'
                height='2.91779'
                transform='rotate(45.5297 6.49414 14.9724)'
                fill='currentColor'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.5035 14.91C15.5755 13.9488 16.25 12.5532 16.25 11C16.25 8.10051 13.8995 5.75 11 5.75C8.10051 5.75 5.75 8.10051 5.75 11C5.75 12.5532 6.42447 13.9488 7.49649 14.91C7.86981 13.9345 8.63883 13.1548 9.60717 12.7672C9.0851 12.3551 8.75 11.7167 8.75 11C8.75 9.75736 9.75736 8.75 11 8.75C12.2426 8.75 13.25 9.75736 13.25 11C13.25 11.7167 12.9149 12.3551 12.3928 12.7672C13.3612 13.1548 14.1302 13.9345 14.5035 14.91ZM13.8758 15.393C13.507 14.1537 12.3591 13.25 11 13.25C9.64094 13.25 8.49295 14.1537 8.12419 15.393C8.95022 15.9349 9.93831 16.25 11 16.25C12.0617 16.25 13.0498 15.9349 13.8758 15.393ZM11 12.5C11.8284 12.5 12.5 11.8284 12.5 11C12.5 10.1716 11.8284 9.5 11 9.5C10.1716 9.5 9.5 10.1716 9.5 11C9.5 11.8284 10.1716 12.5 11 12.5Z'
                fill='currentColor'
            />
        </svg>
    )
}

const TxNavIcon = props => {
    return (
        <svg
            width='1.2em'
            height='1.1em'
            viewBox='0 0 24 18'
            fill={`${props.color || 'currentColor'}`}
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M1.55524 7.9515H22.4448C22.7356 7.9515 23.02 7.87032 23.266 7.71795C23.5119 7.56563 23.7094 7.34851 23.8374 7.09188C23.9654 6.83533 24.0194 6.54877 23.9937 6.26408C23.9681 5.97938 23.8639 5.70662 23.6916 5.47647L20.5582 1.28969C20.4363 1.12689 20.2832 0.98914 20.1073 0.884728C19.9313 0.780304 19.736 0.711376 19.5326 0.682259C19.3292 0.653141 19.1221 0.664471 18.9232 0.71553C18.7244 0.766585 18.538 0.856264 18.3747 0.979004C18.2114 1.10173 18.0745 1.25504 17.9712 1.42982C17.8679 1.60459 17.8003 1.79759 17.7717 1.9978C17.7432 2.198 17.7543 2.40189 17.8044 2.59794C17.8545 2.794 17.9428 2.97875 18.0646 3.14153L19.3457 4.85328H1.55524C1.13974 4.85328 0.743197 5.01877 0.452308 5.31028C0.161731 5.60147 0.000122071 5.99448 0.000122071 6.40239C0.000122071 6.81029 0.161731 7.20331 0.452308 7.4945C0.743197 7.78601 1.13974 7.9515 1.55524 7.9515ZM1.15801 7.37043C1.28259 7.42163 1.41705 7.4487 1.55431 7.4487H22.4439C22.6379 7.4487 22.828 7.39457 22.993 7.29238C23.158 7.19019 23.2914 7.04397 23.3781 6.8701C23.4649 6.69624 23.5016 6.50161 23.4842 6.30801C23.4668 6.11441 23.3959 5.9295 23.2795 5.77399L20.1461 1.58721C20.0638 1.47725 19.9607 1.38461 19.8426 1.31458C19.7994 1.28895 19.7546 1.26653 19.7083 1.24745C19.7549 1.26661 19.8001 1.28916 19.8436 1.31496C19.9616 1.38499 20.0647 1.47763 20.147 1.58759L23.2804 5.77437C23.3968 5.92988 23.4677 6.11479 23.4851 6.30839C23.5025 6.50199 23.4658 6.69662 23.379 6.87048C23.2923 7.04435 23.159 7.19057 22.9939 7.29276C22.8289 7.39495 22.6388 7.44908 22.4448 7.44908H1.55524C1.41764 7.44908 1.28285 7.42188 1.15801 7.37043ZM4.22654 17.3896C4.32536 17.4384 4.43143 17.4714 4.54084 17.487C4.67663 17.5065 4.8149 17.4989 4.94778 17.4648C5.08065 17.4307 5.20551 17.3707 5.31524 17.2882C5.42497 17.2057 5.51742 17.1024 5.5873 16.9841C5.65719 16.8659 5.70314 16.735 5.72254 16.5989C5.74194 16.4628 5.7344 16.3242 5.70036 16.1911C5.66632 16.0579 5.60644 15.9328 5.52414 15.8228L3.64408 13.3108H22.4447C22.7217 13.3108 22.9874 13.2005 23.1833 13.0042C23.3792 12.8079 23.4892 12.5417 23.4892 12.2641C23.4892 11.9865 23.3792 11.7202 23.1833 11.524C23.1028 11.4433 23.0106 11.3772 22.9107 11.3273C23.0103 11.3772 23.1022 11.4432 23.1825 11.5236C23.3784 11.7198 23.4884 11.9861 23.4884 12.2637C23.4884 12.5413 23.3784 12.8075 23.1825 13.0038C22.9866 13.2001 22.7209 13.3104 22.4439 13.3104H3.64327L5.52334 15.8224C5.60563 15.9324 5.66551 16.0575 5.69955 16.1907C5.73359 16.3238 5.74113 16.4624 5.72173 16.5985C5.70234 16.7346 5.65638 16.8655 5.5865 16.9837C5.51662 17.102 5.42417 17.2053 5.31444 17.2878C5.20471 17.3703 5.07984 17.4303 4.94697 17.4644C4.8141 17.4985 4.67582 17.5061 4.54004 17.4866C4.43092 17.471 4.32513 17.4382 4.22654 17.3896ZM22.4447 10.715H1.55512C1.26436 10.715 0.979995 10.7961 0.733973 10.9485C0.488042 11.1008 0.290563 11.318 0.162523 11.5746C0.034518 11.8311 -0.0194056 12.1177 0.00621015 12.4024C0.0318273 12.6871 0.136096 12.9598 0.308347 13.19L3.44179 17.3768C3.56363 17.5396 3.71673 17.6773 3.89269 17.7817C4.06868 17.8862 4.26393 17.9551 4.46732 17.9842C4.67072 18.0133 4.87783 18.002 5.0767 17.9509C5.27557 17.8999 5.46191 17.8102 5.62522 17.6875C5.78851 17.5647 5.92549 17.4114 6.02876 17.2366C6.13202 17.0619 6.19968 16.8689 6.22822 16.6687C6.25676 16.4685 6.24569 16.2646 6.19557 16.0685C6.14544 15.8725 6.05715 15.6877 5.93532 15.5249L4.65423 13.8132H22.4447C22.8602 13.8132 23.2568 13.6477 23.5476 13.3562C23.8382 13.065 23.9998 12.672 23.9998 12.2641C23.9998 11.8562 23.8382 11.4632 23.5476 11.172C23.2568 10.8805 22.8602 10.715 22.4447 10.715Z'
            />
        </svg>
    )
}

const BlockNavIcon = props => {
    return (
        <svg
            width='1.2em'
            height='1.2em'
            viewBox='0 0 24 26'
            fill={`${props.color || 'currentColor'}`}
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M23.9735 6.9328C23.9735 6.90603 23.9735 6.90603 23.9735 6.87925C23.947 6.82569 23.947 6.77213 23.9205 6.71858V6.6918C23.894 6.63824 23.8411 6.58469 23.8146 6.55791L23.7881 6.53113C23.7616 6.50435 23.7086 6.47757 23.6821 6.45079L23.6556 6.42402H23.6291L23.6026 6.39724L12.3444 0.747022C12.1325 0.639909 11.8675 0.639909 11.6291 0.747022L7.84106 2.64828L19.1523 8.51272L19.1788 8.5395C19.2053 8.5395 19.2053 8.56628 19.2318 8.56628C19.2583 8.59306 19.2583 8.61984 19.2848 8.64661C19.2848 8.67339 19.2848 8.67339 19.2848 8.70017V8.72695V14.9395C19.2848 15.0466 19.2318 15.127 19.1523 15.1805L16.8742 16.3855C16.7417 16.4659 16.5828 16.4123 16.5033 16.2784C16.4768 16.2516 16.4768 16.1981 16.4768 16.1445V10.0659L5.03311 4.09431L5.00662 4.06753L0.423841 6.37046L0.397351 6.39724H0.370861L0.344371 6.42402C0.317881 6.45079 0.264901 6.47757 0.238411 6.50435L0.211921 6.53113C0.15894 6.58469 0.13245 6.63824 0.0794702 6.6918V6.71858C0.0529801 6.77213 0.0264901 6.82569 0.0264901 6.87925C0.0264901 6.90603 0.0264901 6.90603 0.0264901 6.9328C0.0264901 6.98636 0 7.01314 0 7.06669V7.09347V19.5721C0 19.8667 0.15894 20.1613 0.450331 20.2952L11.6026 25.9186C11.7616 25.9989 11.947 26.0257 12.1325 25.9722L12.1854 25.9454C12.2384 25.9454 12.2649 25.9186 12.3179 25.8918L23.5497 20.2684C23.8146 20.1345 24 19.8667 24 19.5454V7.09347V7.06669C23.9735 7.01314 23.9735 6.98636 23.9735 6.9328Z' />
        </svg>
    )
}

const AccountNavIcon = props => {
    return (
        <svg
            width='1.1em'
            height='1.2em'
            viewBox='0 2 25 23'
            fill={`${props.color || 'currentColor'}`}
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M0.666748 22.6667C0.666748 20.3765 1.57984 18.1802 3.20516 16.5609C4.83047 14.9415 7.03487 14.0317 9.33342 14.0317C11.632 14.0317 13.8364 14.9415 15.4617 16.5609C17.087 18.1802 18.0001 20.3765 18.0001 22.6667H0.666748ZM9.33342 12.9524C5.74216 12.9524 2.83341 10.0543 2.83341 6.47619C2.83341 2.89809 5.74216 0 9.33342 0C12.9247 0 15.8334 2.89809 15.8334 6.47619C15.8334 10.0543 12.9247 12.9524 9.33342 12.9524Z' />
        </svg>
    )
}

const PeersNavIcon = props => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            height='1.2em'
            viewBox='0 -8 480 480'
            width='1.2em'
            fill={props.color || 'currentColor'}
        >
            <path d='m324.6875 128h-121.015625c-16.472656 19.121094-28.246094 31.710938-36.761719 40h117.777344zm0 0' />
            <path d='m336 139.3125-40 40v121.375l40-40zm0 0' />
            <path d='m152 312h128v-128h-128zm32-96h32c10.132812.042969 19.148438 6.445312 22.527344 16h9.472656c13.253906 0 24 10.746094 24 24s-10.746094 24-24 24h-32c-10.132812-.042969-19.148438-6.445312-22.527344-16h-9.472656c-13.253906 0-24-10.746094-24-24s10.746094-24 24-24zm0 0' />
            <path d='m400 0h64v32h-64zm0 0' />
            <path d='m16 384h64v32h-64zm0 0' />
            <path d='m248 264c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-9.472656c-3.378906 9.554688-12.394532 15.957031-22.527344 16zm0 0' />
            <path d='m184 248h9.472656c3.378906-9.554688 12.394532-15.957031 22.527344-16h-32c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0' />
            <path d='m416 352c-26.507812 0-48 21.492188-48 48s21.492188 48 48 48 48-21.492188 48-48c-.027344-26.5-21.5-47.972656-48-48zm6.855469 68.121094c-1.125 1.871094-2.964844 3.203125-5.09375 3.6875-.578125.125-1.167969.191406-1.761719.191406-1.578125-.003906-3.125-.46875-4.441406-1.34375l-24-16 8.882812-13.3125 17.015625 11.34375 19.6875-32.800781 13.710938 8.242187zm0 0' />
            <path d='m64 96c26.507812 0 48-21.492188 48-48s-21.492188-48-48-48-48 21.492188-48 48c.027344 26.5 21.5 47.972656 48 48zm-19.558594-54.65625 17.015625 11.34375 19.6875-32.800781 13.710938 8.242187-24 40c-1.125 1.871094-2.964844 3.207032-5.09375 3.6875-.582031.125-1.171875.183594-1.761719.183594-1.578125-.003906-3.125-.46875-4.441406-1.34375l-24-16zm0 0' />
            <path d='m464 64h-24v-16h-16v16h-24v16h64zm0 0' />
            <path d='m56 432h-16v16h-24v16h64v-16h-24zm0 0' />
            <path d='m368 16v-16h-261.761719c5.222657 4.578125 9.65625 9.980469 13.121094 16zm0 0' />
            <path d='m56 184v-72.480469l-16-4.238281v80c5.058594-2.160156 10.5-3.277344 16-3.28125zm0 0' />
            <path d='m40 260.71875v91.28125h16v-88c-5.5-.003906-10.941406-1.121094-16-3.28125zm0 0' />
            <path d='m112 392h240.480469v16h-240.480469zm0 0' />
            <path d='m424 336.480469 16 4.238281v-80c-5.058594 2.160156-10.5 3.277344-16 3.28125zm0 0' />
            <path d='m440 187.28125v-91.28125h-16v88c5.5.003906 10.941406 1.121094 16 3.28125zm0 0' />
            <path d='m392 248h32c13.253906 0 24-10.746094 24-24s-10.746094-24-24-24h-32c-13.253906 0-24 10.746094-24 24s10.746094 24 24 24zm0-32h32c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8h-32c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8zm0 0' />
            <path d='m88 200h-32c-13.253906 0-24 10.746094-24 24s10.746094 24 24 24h32c13.253906 0 24-10.746094 24-24s-10.746094-24-24-24zm0 32h-32c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8h32c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8zm0 0' />
            <path d='m463.199219 216c1.066406 5.28125 1.066406 10.71875 0 16h16.800781v-16zm0 0' />
            <path d='m16 224c-.019531-2.6875.25-5.371094.800781-8h-16.800781v16h16.800781c-.550781-2.628906-.820312-5.3125-.800781-8zm0 0' />
        </svg>
    )
}

const ToolNavIcon = props => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='1.4em'
            height='1.4em'
            fill={`${props.color || 'none'}`}
            version='1.1'
            id='Capa_1'
            x='0px'
            y='0px'
            viewBox='0 0 512 512'
        >
            <g>
                <g>
                    <path d='M453.584,237.313c-1.509-18.762-5.638-37.015-12.335-54.508l46.141-36.955l-74.979-93.622L366.55,88.953    c-15.833-10.666-32.956-18.902-51.119-24.58V6.097H195.48v58.656c-18.992,6.078-36.815,14.964-53.228,26.529L95.911,55.267    l-73.61,94.711l47.161,36.645c-6.297,17.533-10.046,35.765-11.195,54.458L0,255.025l27.909,116.652l40.993-9.806    c20.193-20.193,38.423-38.423,62.394-62.394c-31.861-86.471,32.191-178.907,124.789-178.907    c73.42,0,132.945,59.526,132.945,132.945c0,90.681-88.981,154.709-174.778,126.218c-6.853,6.853-77.854,77.854-88.884,88.884    l79.098,37.285l26.309-55.817c18.173,2.339,36.305,2.149,54.128-0.45l26.949,55.077l107.746-52.718l-26.879-54.937    c13.315-12.665,24.73-27.009,34.056-42.832l59.026,13.215L512,250.387L453.584,237.313z' />
                </g>
            </g>
            <g>
                <g>
                    <path d='M341.29,219.06l-8.417-21.171l-50.649,50.639l-22.751-22.751l50.649-50.639l-21.171-8.427    c-82.867-32.961-159.477,57.699-115.992,133.505C61.094,412.082,156.695,316.491,22.301,450.885l39.194,39.194    c78.071-78.071,2.238-2.227,152.058-152.048C290.032,375.121,372.837,298.314,341.29,219.06z' />
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    )
}

const DigitalProfileIcon = props => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            fill={props.color || 'currentColor'}
            width='1.3em'
            height='1.3em'
            version='1.1'
            id='Capa_1'
            x='0px'
            y='0px'
            viewBox='0 0 512 512'
        >
            <g>
                <g>
                    <path d='M414.007,148.75c5.522,0,10-4.477,10-10V30c0-16.542-13.458-30-30-30h-364c-16.542,0-30,13.458-30,30v452    c0,16.542,13.458,30,30,30h364c16.542,0,30-13.458,30-30v-73.672c0-5.523-4.478-10-10-10c-5.522,0-10,4.477-10,10V482    c0,5.514-4.486,10-10,10h-364c-5.514,0-10-4.486-10-10V30c0-5.514,4.486-10,10-10h364c5.514,0,10,4.486,10,10v108.75    C404.007,144.273,408.485,148.75,414.007,148.75z' />
                </g>
            </g>
            <g>
                <g>
                    <path d='M212.007,54c-50.729,0-92,41.271-92,92c0,26.317,11.11,50.085,28.882,66.869c0.333,0.356,0.687,0.693,1.074,1    c16.371,14.979,38.158,24.13,62.043,24.13c23.885,0,45.672-9.152,62.043-24.13c0.387-0.307,0.741-0.645,1.074-1    c17.774-16.784,28.884-40.552,28.884-66.869C304.007,95.271,262.736,54,212.007,54z M212.007,218    c-16.329,0-31.399-5.472-43.491-14.668c8.789-15.585,25.19-25.332,43.491-25.332c18.301,0,34.702,9.747,43.491,25.332    C243.405,212.528,228.336,218,212.007,218z M196.007,142v-6.5c0-8.822,7.178-16,16-16s16,7.178,16,16v6.5c0,8.822-7.178,16-16,16    S196.007,150.822,196.007,142z M269.947,188.683c-7.375-10.938-17.596-19.445-29.463-24.697c4.71-6.087,7.523-13.712,7.523-21.986    v-6.5c0-19.851-16.149-36-36-36s-36,16.149-36,36v6.5c0,8.274,2.813,15.899,7.523,21.986    c-11.867,5.252-22.088,13.759-29.463,24.697c-8.829-11.953-14.06-26.716-14.06-42.683c0-39.701,32.299-72,72-72s72,32.299,72,72    C284.007,161.967,278.776,176.73,269.947,188.683z' />
                </g>
            </g>
            <g>
                <g>
                    <path d='M266.007,438h-54c-5.522,0-10,4.477-10,10s4.478,10,10,10h54c5.522,0,10-4.477,10-10S271.529,438,266.007,438z' />
                </g>
            </g>
            <g>
                <g>
                    <path d='M266.007,382h-142c-5.522,0-10,4.477-10,10s4.478,10,10,10h142c5.522,0,10-4.477,10-10S271.529,382,266.007,382z' />
                </g>
            </g>
            <g>
                <g>
                    <path d='M266.007,326h-142c-5.522,0-10,4.477-10,10s4.478,10,10,10h142c5.522,0,10-4.477,10-10S271.529,326,266.007,326z' />
                </g>
            </g>
            <g>
                <g>
                    <path d='M88.366,272.93c-1.859-1.86-4.439-2.93-7.079-2.93c-2.631,0-5.211,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07    s1.069,5.21,2.93,7.07c1.87,1.86,4.439,2.93,7.07,2.93c2.64,0,5.21-1.07,7.079-2.93c1.86-1.86,2.931-4.44,2.931-7.07    S90.227,274.79,88.366,272.93z' />
                </g>
            </g>
            <g>
                <g>
                    <path d='M88.366,328.93c-1.869-1.86-4.439-2.93-7.079-2.93c-2.631,0-5.2,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07    s1.069,5.21,2.93,7.07c1.87,1.86,4.439,2.93,7.07,2.93c2.64,0,5.21-1.07,7.079-2.93c1.86-1.86,2.931-4.44,2.931-7.07    S90.227,330.79,88.366,328.93z' />
                </g>
            </g>
            <g>
                <g>
                    <path d='M88.366,384.93c-1.869-1.86-4.439-2.93-7.079-2.93c-2.631,0-5.2,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07    s1.069,5.21,2.93,7.07c1.859,1.86,4.439,2.93,7.07,2.93c2.64,0,5.22-1.07,7.079-2.93c1.86-1.86,2.931-4.44,2.931-7.07    S90.227,386.79,88.366,384.93z' />
                </g>
            </g>
            <g>
                <g>
                    <path d='M266.007,270h-142c-5.522,0-10,4.477-10,10s4.478,10,10,10h142c5.522,0,10-4.477,10-10S271.529,270,266.007,270z' />
                </g>
            </g>
            <g>
                <g>
                    <path d='M491.002,130.32c-9.715-5.609-21.033-7.099-31.871-4.196c-10.836,2.904-19.894,9.854-25.502,19.569L307.787,363.656    c-0.689,1.195-1.125,2.52-1.278,3.891l-8.858,79.344c-0.44,3.948,1.498,7.783,4.938,9.77c1.553,0.896,3.278,1.34,4.999,1.34    c2.092,0,4.176-0.655,5.931-1.948l64.284-47.344c1.111-0.818,2.041-1.857,2.73-3.052l125.841-217.963    C517.954,167.638,511.058,141.9,491.002,130.32z M320.063,426.394l4.626-41.432l28.942,16.71L320.063,426.394z M368.213,386.996    l-38.105-22l100.985-174.91l38.105,22L368.213,386.996z M489.054,177.693l-9.857,17.073l-38.105-22l9.857-17.073    c2.938-5.089,7.682-8.729,13.358-10.25c5.678-1.522,11.606-0.74,16.694,2.198c5.089,2.938,8.729,7.682,10.25,13.358    C492.772,166.675,491.992,172.604,489.054,177.693z' />
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    )
}

const LookupNavIcon = props => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            id='Icons'
            fill={`${props.color || 'currentColor'}`}
            height='1.4em'
            viewBox='0 0 60 60'
            width='1.4em'
        >
            <path d='m25 14h-8v5h4v-1a2 2 0 0 1 2-2h2z' />
            <path d='m26 6a20 20 0 1 0 20 20 20.023 20.023 0 0 0 -20-20zm10.445 18.168 3-2a1 1 0 1 1 1.11 1.664l-3 2a1 1 0 0 1 -1.11-1.664zm-6.445-6.168a1 1 0 0 1 2 0v4a1 1 0 0 1 -2 0zm-9 15a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2-2v-2h-1a2 2 0 0 1 -2-2v-4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2zm2-14a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2-2v-5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2zm10 20a1 1 0 0 1 -2 0v-4a1 1 0 0 1 2 0zm1-9.618a1.99 1.99 0 0 1 -1.1 1.789l-6 3a1.988 1.988 0 0 1 -1.947-.088 1.986 1.986 0 0 1 -.948-1.7v-5.383a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2zm6.832 4.173a1 1 0 0 1 -1.387.277l-3-2a1 1 0 0 1 1.11-1.664l3 2a1 1 0 0 1 .277 1.387z' />
            <path d='m14 29h1a2 2 0 0 1 2 2v2h2v-8h-5z' />
            <path d='m26 32.382 6-3v-2.382h-6z' />
            <path d='m50 26a24 24 0 1 0 -24 24 24.028 24.028 0 0 0 24-24zm-24 22a22 22 0 1 1 22-22 22.025 22.025 0 0 1 -22 22z' />
            <path d='m56.434 50.5-10.181-8.22a26.2 26.2 0 0 1 -3.974 3.974l8.221 10.178a4.219 4.219 0 1 0 5.934-5.932z' />
        </svg>
    )
}

const VerifyIcon = props => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            id='Layer_1'
            enable-background='new 0 0 512.063 512.063'
            height='1.2em'
            viewBox='0 0 512.063 512.063'
            width='1.2em'
        >
            <g>
                <g>
                    <ellipse cx='256.032' cy='256.032' fill='#00df76' rx='255.949' ry='256.032' />
                </g>
                <path
                    d='m256.032 0c-.116 0-.231.004-.347.004v512.055c.116 0 .231.004.347.004 141.357 0 255.949-114.629 255.949-256.032s-114.592-256.031-255.949-256.031z'
                    fill='#00ab5e'
                />
                <path
                    d='m111.326 261.118 103.524 103.524c4.515 4.515 11.836 4.515 16.351 0l169.957-169.957c4.515-4.515 4.515-11.836 0-16.351l-30.935-30.935c-4.515-4.515-11.836-4.515-16.351 0l-123.617 123.615c-4.515 4.515-11.836 4.515-16.351 0l-55.397-55.397c-4.426-4.426-11.571-4.526-16.119-.226l-30.83 29.149c-4.732 4.475-4.837 11.973-.232 16.578z'
                    fill='#fff5f5'
                />
                <path
                    d='m370.223 147.398c-4.515-4.515-11.836-4.515-16.351 0l-98.187 98.187v94.573l145.473-145.473c4.515-4.515 4.515-11.836 0-16.352z'
                    fill='#dfebf1'
                />
            </g>
        </svg>
    )
}

const VerifyFailIcon = props => {
    return (
        <svg
            height='1.2em'
            width='1.2em'
            xmlns='http://www.w3.org/2000/svg'
            version='1.1'
            id='Capa_1'
            x='0px'
            y='0px'
            viewBox='0 0 512 512'
        >
            <path fill='#FF3636' d='M256,0C115.3,0,0,115.3,0,256s115.3,256,256,256s256-115.3,256-256S396.7,0,256,0z' />
            <path fill='#F40000' d='M512,256c0,140.7-115.3,256-256,256V0C396.7,0,512,115.3,512,256z' />
            <polygon
                fill='#E7E7E7'
                points='298.299,256 383.2,340.901 340.901,383.2 256,298.299 171.099,383.2 128.8,340.901   213.701,256 128.8,171.099 171.099,128.8 256,213.701 340.901,128.8 383.2,171.099 '
            />
            <polygon
                fill='#D3D3D8'
                points='298.299,256 383.2,340.901 340.901,383.2 256,298.299 256,213.701 340.901,128.8   383.2,171.099 '
            />
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    )
}

module.exports = {
    BlockNavIcon,
    TxNavIcon,
    AccountNavIcon,
    LookupNavIcon,
    ToolNavIcon,
    BlockchainNavIcon,
    DigitalProfileIcon,
    PeersNavIcon,
    VerifyIcon,
    VerifyFailIcon
}
